import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { styled } from '@mui/material/styles'
import { LoadingButton } from '@mui/lab'
import Button from '@mui/material/Button'
import { Typography } from '@mui/material'

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

// Define StyledDialog once so it isn't recreated on every render. Use ownerState
// to control the mobile layout so callers can pass `isMobile` as a prop.
const StyledDialog = styled(Dialog, { shouldForwardProp: (prop) => prop !== 'isMobile' })(({ theme, ownerState }) => [
  {
    '& .MuiPaper-root': {
      background: theme.palette.background.default
    }
  },
  ownerState && ownerState.isMobile
    ? {
        '& .MuiPaper-root': {
          width: '100%',
          margin: '0'
        }
      }
    : null
])

export const DeckMappDialog = React.memo(function DeckMappDialog_({
  title,
  subtitle,
  Actions,
  open,
  maxWidth,
  color,
  saveButtonProps,
  onCancel,
  isLoading,
  children,
  isMobile: mobileProp
}) {
  return (
    <StyledDialog open={open} fullWidth maxWidth={maxWidth} isMobile={mobileProp ?? isMobile}>
      <DialogTitle
        color={color ?? 'secondary'}
        sx={{
          zIndex: 100000
        }}>
        {title}
        {subtitle && (
          <Typography variant="body1" sx={{ marginTop: '0.25em', color: 'rgba(255, 255, 255, 0.7)', fontSize: '.7em' }}>
            {subtitle}
          </Typography>
        )}
      </DialogTitle>

      <DialogContent>{children}</DialogContent>
      {!!Actions && <DialogActions>{Actions}</DialogActions>}
      {!!saveButtonProps && (
        <DialogActions>
          <Button disabled={isLoading} variant="outlined" color="secondary" onClick={() => onCancel?.(undefined)}>
            {saveButtonProps.negativeButtonTitle ?? 'Cancel'}
          </Button>
          <LoadingButton loading={isLoading} variant="contained" color="secondary" {...saveButtonProps}>
            {saveButtonProps.title ?? 'Save'}
            {saveButtonProps.children}
          </LoadingButton>
        </DialogActions>
      )}
    </StyledDialog>
  )
})
